
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { AngularJsonFormModule } from "angular-json-form";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MomentDateModule, MomentDateAdapter } from "@angular/material-moment-adapter";
import { MatIconModule } from "@angular/material/icon";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatButtonModule } from "@angular/material/button";
import { DialogStepperComponent } from "./dialog-stepper.component";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTabsModule } from "@angular/material/tabs";
import { MatGridListModule } from "@angular/material/grid-list";
import { TranslateModule } from "@ngx-translate/core";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import {
  NgxMatDatepickerActions,
  NgxMatDatepickerInput,
  NgxMatDatetimepicker,
  NgxMatNativeDateModule
} from "@ngxmc/datetime-picker";
import { CommonModule } from "@angular/common";

export const DATE_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY"
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MM YYYY",
    dateA11yLabel: "DD/MM/YYYY",
    monthYearA11yLabel: "MM YYYY"
  }
};

@NgModule({
  declarations: [
    DialogStepperComponent
  ],
  exports: [
    DialogStepperComponent
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [
        MAT_DATE_LOCALE
      ]
    }, {
      provide: MAT_DATE_FORMATS,
      useValue: DATE_FORMATS
    }
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatDialogModule,
    AngularJsonFormModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatIconModule,
    MomentDateModule,
    MatSnackBarModule,
    MatButtonModule,
    MatStepperModule,
    MatTabsModule, MatGridListModule, TranslateModule, MatAutocompleteModule,
    NgxMatDatetimepicker, NgxMatDatepickerInput, NgxMatDatepickerActions, NgxMatNativeDateModule

  ]
})
export class DialogStepperModule {}